import React, { Component } from 'react';
import loadable from '@loadable/component';
import SnackbarToast from 'elements/UI/Snackbar';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { snackbarClose } from 'store/Actions/UI/SnackbarActions';
import classes from './Home.module.css';
import Header from './Header';

const Sidebar = loadable(() =>
  import(/* webpackChunkName: "Sidebar" */ '../Sidebar/Sidebar')
);
const List = loadable(() =>
  import(/* webpackChunkName: "List" */ '../List/List')
);

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mwbList: '',
    };

    this.ref = React.createRef();
  }

  listChangeHandler = (value) => {
    this.setState({ mwbList: value });
  };

  hideModal = () => {
    document.body.classList.remove('mwb-sidebar-body');
    document.getElementById('overlay').style.display = 'none';
  };

  handleClose = () => {
    const { snackClose } = this.props;
    snackClose();
  };

  render() {
    const { display, match, settings, appHeading } = this.props;
    const { mwbList } = this.state;
    let slug;
    if (Object.keys(match.params).length !== 0) {
      slug = _.last(match.params.category.split('/'));
    }

    return (
      <>
        <div className={`mwb-main-wrapper ${mwbList}`} ref={this.ref}>
          <Header />
          <SnackbarToast open={display} onClose={this.handleClose} />
          <div className="main-wrapper">
            <div id="overlay" onClick={this.hideModal} />
            <div
              className={`${classes.mwb_close_sidebar} mwb_close_mb_sidebar`}
              onClick={this.hideModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="#fff"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </div>
            <div
              className={`${classes.mwb_gallery_sidebar_btn} mwb_list_icon mwb-close-btn mwb-m-btn`}
              onClick={this.hideModal}
              id="mwb_list_btn"
            >
              <div className={classes.mwb_line_wrap}>
                <span className={classes.mwb_line} />
                <span className={classes.mwb_line} />
              </div>
              <svg
                className={classes.mwb_circle_svg}
                x="0px"
                y="0px"
                width="50px"
                height="50px"
                viewBox="0 0 50 50"
                role="button"
              >
                <title>Toggle navigation</title>
                <circle
                  className={classes.mwb_circle}
                  cx="25"
                  cy="25"
                  r="23"
                  stroke="#459fed"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <Sidebar categorySlug={slug} />
            {Object.keys(settings).length > 0 ? (
              <List
                mwbListRef={this.ref}
                categorySlug={slug}
                changeList={(val) => this.listChangeHandler(val)}
                applistHeading={appHeading}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { snackbar } = state;
  const { settings } = state.list;
  return {
    display: snackbar.display,
    settings,
    appHeading: state.list.appHeading,
  };
};

const mapDispatchToProps = {
  snackClose: snackbarClose,
};

Home.propTypes = {
  display: PropTypes.bool,
  snackClose: PropTypes.func,
  match: PropTypes.object,
  settings: PropTypes.object,
  appHeading: PropTypes.string,
};

Home.defaultProps = {
  display: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
